<template>
    <main class="md:px-12 max-w-screen-2xl mx-auto py-10">
     <div class="flex flex-col lg:flex-row items-center bg-[#f5f9ff] p-6 rounded-lg gap-8">
         <!-- Book Image -->
         <div class="flex-shrink-0">
           <img src="../assets/images/newsletter.jpeg" alt="Unlock Book" class="w-64 lg:w-80 rounded-lg shadow-md" />
         </div>
     
         <!-- Content Section -->
         <div class="text-center lg:text-left">
           <!-- Book Tag -->
           <div class="inline-block bg-[#c3e7f7] text-[#1e4d72] px-4 py-1 rounded-full text-sm font-semibold mb-2">
             📘 Newsletter
           </div>
     
           <!-- Heading -->
           <h2 class="text-3xl font-bold text-gray-800 mb-4">UNLOCK Wealth</h2>
     
           <!-- Description -->
           <p class="text-gray-700 max-w-xl mb-6">
             In <strong>UNLOCK: The Secrets to a Winning Life</strong>, BUM presents a guide to personal
             transformation complete with journal, exercises, worksheets for individuals who want to create a Winning Life.
           </p>
     
           <!-- CTA Button -->
           <button @click="openModal" class="bg-gradient rounded-lg text-white px-6 py-2 transition">
             ➔ Download Newsletter
           </button>

            <!-- Modal Section -->
            <div
                v-if="isModalOpen"
                class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4"
              >
                <div
                  class="bg-white px-5 py-8 rounded-lg shadow-xl max-w-lg w-full"
                >
                  <!-- Close Button -->
                  <div class="flex justify-end items-center mb-6">
                    <button
                      @click="closeModal"
                      class="text-gray-500 hover:text-blue text-3xl hover:text-yellow transition"
                    >
                      &times;
                    </button>
                  </div>

                  <!-- Form -->
                  <form>
                    <div class="mb-5">
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >Name</label
                      >
                      <input
                        v-model="formData.name"
                        type="text"
                        class="w-full border rounded-md p-2 focus:ring-blue focus:ring-1 outline-none"
                        required
                      />
                    </div>

                    <div class="mb-5">
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >Email</label
                      >
                      <input
                        v-model="formData.email"
                        type="email"
                        class="w-full border rounded-md p-2 focus:ring-blue focus:ring-1 outline-none"
                        required
                      />
                    </div>

                    <!-- Buttons with Better Spacing and Layout -->
                    <div class="flex flex-col sm:flex-row gap-4">
                      <button
                        type="button"
                        @click="downloadFile('land')"
                        class="flex-1 bg-blue text-white py-2 rounded-md font-medium transition-transform transform hover:scale-110 focus:outline-none focus:ring-4 hover:bg-black hover:text-white"
                      >
                        📂 Download Land
                      </button>
                      <button
                        type="button"
                        @click="downloadFile('house')"
                        class="flex-1 bg-blue text-white py-2 rounded-md font-medium transition-transform transform hover:scale-110 focus:outline-none focus:ring-4 hover:bg-black hover:text-white"
                      >
                        🏠 Download Ultra
                      </button>
                    </div>
                  </form>
                </div>
              </div>
         </div>
     </div>
    </main>
  </template>
  
  <script>
  import {
  showErrorAlert,
  showLoadingAlert,
  showSuccessAlert,
} from "../services/reusableService";
  export default {
    data() {
    return {
      isModalOpen: false,
      formData: {
        name: "",
        email: "",
      },
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    resetForm() {
      this.formData = {
        name: "",
        email: "",
      };
    },
    async downloadFile(type) {
      if (!this.formData.name || !this.formData.email) {
        showErrorAlert("Kindly fill the form before you can download!");
        return;
      }

      const months = [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december",
      ];
      const currentDate = new Date();
      const currentMonth = months[currentDate.getMonth()];
      const currentYear = currentDate.getFullYear();
      const fileName = `${currentMonth}-newsletter-${type}-${currentYear}.pdf`;
      const newsletterUrl = `https://mshelhomes.com/images/pdf/${fileName}`;

      try {
        showLoadingAlert("Preparing your download...");

        // Simulating a small delay for better UX
        setTimeout(() => {
          const a = document.createElement("a");
          a.href = newsletterUrl;
          a.target = "_blank";
          a.download = fileName;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          showSuccessAlert("Download started successfully!");
          this.resetForm();
          this.closeModal();
        }, 1000);
      } catch (error) {
        showErrorAlert("Failed to start download. Please try again!");
      }
    },
  }
  }
  </script>
  
  <style scoped>
  /* You can add any extra styling here if needed */
  </style>
  